module.exports = __webpack_public_path__ + "static/img/syfl-3.85522f7b.jpg";